import React from 'react';
import { STAGES } from '../mock';
import ClosingCTA from '../components/ClosingCTA';

export default function Approach() {
  return (
    <div>
      <section className="pt-16 pb-10">
        <div className="dwx">
          <div className="mono text-[11px] tracking-[0.22em] uppercase text-[#1A1A1A]/60">Approach</div>
          <h1 className="serif-tight text-[64px] md:text-[112px] leading-[0.92] mt-4">Five stages.<br /><span className="text-[#1A1A1A]/50">You choose how far.</span></h1>
          <p className="mt-10 max-w-3xl text-[17px] leading-relaxed text-[#1A1A1A]/80">AI adoption fails when it is attempted all at once. NeuralWorks is adopted in sequence, each stage earning the next.</p>
        </div>
      </section>

      {/* Stage ladder */}
      <section className="py-16">
        <div className="dwx">
          <div className="relative">
            <div className="absolute left-6 md:left-1/2 top-0 bottom-0 w-[2px] bg-gradient-to-b from-[#22A94F] via-[#22A94F] to-[#8A8178]/40"></div>
            <div className="space-y-14">
              {STAGES.map((s, i) => {
                const isOp = s.status === 'operational';
                const leftSide = i % 2 === 0;
                return (
                  <div key={s.stage} className="relative pl-16 md:pl-0 md:grid md:grid-cols-2 md:gap-16">
                    <div className={`absolute left-6 md:left-1/2 -translate-x-1/2 top-4 w-4 h-4 rounded-full ${isOp ? 'bg-[#22A94F]' : 'bg-[#FBFAF6] border-2 border-dashed border-[#8A8178]'}`}></div>
                    <div className={leftSide ? 'md:col-start-1 md:text-right md:pr-16' : 'md:col-start-2 md:pl-16'}>
                      <div className={`mono text-[11px] tracking-[0.22em] uppercase ${isOp ? 'text-[#178838]' : 'text-[#8A8178]'}`}>Stage {s.stage} · {s.status}</div>
                      <h3 className="serif-tight text-[38px] md:text-[52px] leading-[1] mt-2">{s.name}</h3>
                      <div className="mono text-[11px] text-[#1A1A1A]/50 mt-2">{s.horizon}</div>
                      <p className="mt-4 text-[15px] leading-relaxed text-[#1A1A1A]/80 max-w-md md:inline-block">{s.summary}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="mt-16 rounded-[24px] bg-[#F4F2EC] p-10 border border-[#1A1A1A]/10">
            <div className="mono text-[11px] tracking-[0.22em] uppercase text-[#5B4FCF]">The frontier</div>
            <p className="mt-4 text-[16px] leading-relaxed text-[#1A1A1A]/85 max-w-3xl">Stages one and two are running today. Stages three to five are defined and being built, and we develop them with clients rather than ahead of them. We would rather show you the edge of the map than draw territory we have not visited.</p>
          </div>
        </div>
      </section>

      {/* Commercials */}
      <section className="py-24 bg-[#1A1A1A] text-[#FBFAF6]">
        <div className="dwx grid grid-cols-12 gap-10">
          <div className="col-span-12 md:col-span-5">
            <div className="mono text-[11px] tracking-[0.22em] uppercase text-[#22A94F]">Commercials</div>
            <h2 className="serif-tight text-[46px] md:text-[60px] leading-[0.98] mt-3">How engagements are structured.</h2>
          </div>
          <div className="col-span-12 md:col-span-7 space-y-4">
            {[
              ['Fixed-outcome', 'For defined scope. You buy a named result. We take the delivery risk.'],
              ['Capacity', 'Sustained delivery through NeuralWorks. Priced by outcome cadence, not hours.'],
              ['Outcome-share', 'Where the metric is clean enough to share honestly — which is rarer than most firms admit.'],
            ].map(([t, b]) => (
              <div key={t} className="rounded-[16px] bg-[#2B2B2B] p-6 border border-[#FBFAF6]/10">
                <div className="serif text-[24px]">{t}</div>
                <p className="text-[14px] leading-relaxed text-[#FBFAF6]/75 mt-2">{b}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Entry offer */}
      <section className="py-24">
        <div className="dwx">
          <div className="rounded-[28px] bg-[#22A94F] p-12 md:p-16">
            <div className="mono text-[11px] tracking-[0.22em] uppercase text-[#0F5F27] mb-6">Start here</div>
            <h2 className="serif-tight text-[48px] md:text-[72px] leading-[0.98] text-[#0F5F27] max-w-3xl">The Adoption Sprint.</h2>
            <p className="mt-8 max-w-2xl text-[16px] leading-relaxed text-[#0F5F27]/85">Eight weeks, fixed price. We onboard one product area to Tests as Spec, establish end-to-end coverage on its existing features, and run the first agent-delivered changes through the full review and release path. You end with working software, a measured baseline, and enough evidence to decide about everything else.</p>
          </div>
        </div>
      </section>

      <ClosingCTA />
    </div>
  );
}
